import { useState, useEffect, useRef } from "react";
import { MapContainer, TileLayer, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

function ButtonPage({ children }) {
  return (
    <div className="buttonpage">
      {children}
      iOS version coming soon!
    </div>
  )
}

function TaxonPage(props) {

  function Location({ lat, lng, go }) {

    const [locerror, setLocError] = useState(null);
    const [locLoaded, setLocLoaded] = useState(false);
    const [location, setLocation] = useState([]);

    useEffect(() => {

      fetch('https://nominatim.openstreetmap.org/reverse?format=json&lat=' + lat + '&lon=' + lng + '&zoom=12&addressdetails=1')
        .then((resp) => resp.json())
        .then(
          (result) => {
            setLocLoaded(true);
            setLocation(result);
            // console.log(result);
          },
          // Note: it's important to handle errors here
          // instead of a catch() block so that we don't swallow
          // exceptions from actual bugs in components.
          (error) => {
            setLocLoaded(true);
            setLocError(error);
          }
        )
    }, [go])

    if (locerror) {
      return <div>Server busy - please try again later</div>;
    } else if (!locLoaded) {
      return <div>Finding location...</div>;
    } else {
      return (
        location.display_name.split(',')[0] + ' area:'
      );
    }
  }

  return (
    <div className="taxonpage">
      <h1>Nature Near You</h1>
      <div className="placetime">        
        {props.daterange}
      </div>
      <Inat tax="3" title="Birds" {...props} />
      <Inat tax="50814" title="Fungi" {...props} />
      <Inat tax="47157" title="Butterflies and Moths" {...props} />
      <Inat tax="47208" title="Beetles" {...props} />
      <Inat tax="630955" title="Bees" {...props} />
      <Inat tax="342614" title="Spiders" {...props} />
      <Inat tax="47217" title="Orchids"{...props} />
      <Inat tax="40151" title="Mammals" {...props} />
      <Inat tax="311249" title="Moss" {...props} />
    </div>
  )
}



function Inat(props) {
  // console.log('inat',props);
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);
  const url = 'https://api.inaturalist.org/v1/observations/species_counts?taxon_id=' + props.tax + '&lat=' + props.lat + '&lng=' + props.lng + '&radius=10&quality_grade=research' + '&month=' + props.monthrange;


  useEffect(() => {

    fetch(url)
      .then((resp) => resp.json())
      .then(
        (result) => {
          setIsLoaded(true);
          setItems(result);
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      )
  }, [isLoaded])

  if (error) {
    return <div>Server busy - please try again later</div>;
  } else if (!isLoaded) {
    return <div>Loading...</div>;
  } else {
    return (
      <Bar items={items} {...props} />
    );
  }
}

function Bar(props) {
  // console.log('bar',props);


  const styles = {
    color: "white",
    backgroundColor: "rgb(20, 194, 20)",
    width: `${props.items.total_results / 4}vw`,
    position: "absolute",
    height: "6vh",
    zIndex: -1,
    transitionDuration: "1s"
  };

  return (
    <div className="barholder" >
      <div className="bar" style={styles}></div>
      <button id="barbutt" onClick={() => { props.func(props) }}>{props.title}{': '}{props.items.total_results}</button>
    </div>
  );
}

function LeafletMap(props) {
  return (
    <div className="map" id="map">
      <MapContainer center={[props.lat, props.lng]} zoom={13} scrollWheelZoom={false} >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <TileLayer
          attribution="<a href=&quot;https://www.inaturalist.org/&quot;>iNaturalist</a>"
          url={`https://api.inaturalist.org/v1/colored_heatmap/{z}/{x}/{y}.png?taxon_id=` + props.tax + `&month=` + props.monthrange}
        />
      </MapContainer>
    </div>
  );
}

function SpeciesPage(props) {

  // console.log('species',props);
  const listItems = props.taxon.results.map(species =>
    <div key={species.taxon.id} className="speciesbox">
      <div className="speciesimage">
        <img src={species.taxon.default_photo.medium_url} alt={species.taxon.name}
        />
        <h3 id="count">{species.count}</h3>
      </div>
      <div className="speciestitle">
        <h3 id="common">{species.taxon.preferred_common_name}</h3>
        <h3><i>{species.taxon.name}</i></h3>
      </div>
    </div>
  );
  return (
    <div className="speciespage">
      <h1>{props.taxontitle.current}</h1>
      <button id="back" onClick={() => { props.backfunc(props) }}>Back</button>
      <LeafletMap lat={props.lat} lng={props.lng} tax={props.taxonid.current} monthrange={props.monthrange} />
      <div className="speciesboxes">
        {listItems}
      </div>

    </div>
  );
}

function Footer() {
  return (
    <div className="footer">
      <a href="https://www.inaturalist.org/" target='_blank'>Data from iNaturalist</a>
      <a href="https://www.zebracow.com" target='_blank'>©Zebracow</a>
    </div>
  );
}

function App() {

  const [lat, setLat] = useState(null);
  const [lng, setLng] = useState(null);
  const [status, setStatus] = useState(null);
  const [go, setGo] = useState(null);
  const [taxon, setTaxon] = useState(null);
  const [showSpecies, setShowSpecies] = useState(null);
  const [showTaxon, setShowTaxon] = useState(true);
  const taxontitle = useRef(null);
  const taxonid = useRef(null);

  const d = new Date();
  const month = d.getMonth();
  const monthpre = (d.getMonth() - 1);
  const monthpost = (d.getMonth() + 1);
  const year = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const daterange = year[monthpre] + ' to ' + year[monthpost];
  const monthrange = monthpre + '%2C' + month + '%2C' + monthpost;


  useEffect(() => {
    getLocation();
  }, []);

  function handletaxon(props) {
    // console.log('handle',props);
    setTaxon(props.items);
    setShowSpecies(true);
    setShowTaxon(false);
    taxontitle.current = props.title;
    taxonid.current = props.tax;

  }

  function backfunc(props) {
    setShowSpecies(false);
    setShowTaxon(true);
  }



  const getLocation = () => {
    if (!navigator.geolocation) {
      setStatus('Geolocation is not supported by your browser');
    } else {
      setStatus('Locating...');
      navigator.geolocation.getCurrentPosition((position) => {
        setStatus(null);
        setLat(position.coords.latitude);
        setLng(position.coords.longitude);
      }, () => {
        setStatus('Unable to retrieve your location');
      });
    }
  }

  return (
    <div className="page">
      {!go && <ButtonPage><button id="start" onClick={() => { setGo(!go); }}>Nature Near You</button></ButtonPage>}
      {(go && lat && showTaxon) && <TaxonPage lat={lat} lng={lng} func={handletaxon} showSpecies={showSpecies} showTaxon={showTaxon} go={go} taxon={taxon} daterange={daterange} monthrange={monthrange} />}
      {showSpecies && <SpeciesPage taxon={taxon} showSpecies={showSpecies} showTaxon={showTaxon} backfunc={backfunc} go={go} lat={lat} lng={lng} taxontitle={taxontitle} taxonid={taxonid} monthrange={monthrange} />}
      <Footer />
    </div>
  )

}

export default App
